<template>
   <footer class="page-footer font-small stylish-color-dark mt-2">
   <hr>
   <div class="footer-copyright text-center py-3">© 2018 HugooDev
   </div>
   <a class="adminLink" href="http://denys.photos/admin">admin login</a>

   </footer>
                        
</template>

<script>
export default {
  name: 'footerFooter',

  data () {
    return {
    }
  }
}
   
</script>
<style scoped>
   hr{
      background-color:rgba(255, 255, 255, 0.5);
      width:69%;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
   }
   .footer-copyright.text-center.py-3{
      text-shadow: 2px 2px 15px rgba(0, 0, 0, 0.466);
   }
   .adminLink{
     font-size:6px;
     position:absolute;
     right:2%;
     
   }
</style>





// WEBPACK FOOTER //
// src/components/footer.vue